import { render, staticRenderFns } from "./FileSelectorModal.vue?vue&type=template&id=534fa664&scoped=true"
import script from "./FileSelectorModal.vue?vue&type=script&lang=js"
export * from "./FileSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./FileSelectorModal.vue?vue&type=style&index=0&id=534fa664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534fa664",
  null
  
)

export default component.exports